import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminObservabilityHub = lazy(() => import("@/pages/admin/AdminObservabilityHub"));

export const Route = createFileRoute("/admin/observability")({
  component: AdminObservabilityHub,
});
